import React, {useState} from "react";
import Header from "../../component/header";
import Footer from "../../component/footer";
import Interaction from "./interaction";
import Classtest from "./classtest";
import Popup from "./popup";
import Player from 'griffith'

let datainit=[
    {className:'inter-sun',title:'金樽', info: '金樽是珍贵的酒器，象征高贵与美好。',
        showdata:'（1）李白以“金樽”代指美酒，强调人生得意之时应尽情享受，不让酒杯空对明月。'+
            '（2）表达情感：自信豪迈、及时行乐——即使仕途失意，仍以金樽对月展现昂扬斗志，是盛唐气象的缩影。'
    },
    {className:'inter-pubu',title:'浊酒 ', info: '浊酒是粗糙、未过滤的酒，象征生活的困顿与朴素。',
        showdata:'（1）杜甫因病连浊酒都不能饮，更显悲凉。'+
            '（2）表达情感：沉郁悲悯、身世之痛——以浊酒承载个人漂泊与家国动荡，体现乱世文人的深沉哀愁。'
    },
    {className:'inter-zhu',title:'绿蚁酒', info: '绿蚁指新酿米酒上浮起的绿色泡沫，形容酒的质朴新鲜。与红泥火炉相映，营造温暖闲适的氛围。',
        showdata:'表达情感：温情闲适、友情可贵——冬日邀友共饮，酒中是对平淡生活的满足与对友人的真挚情谊。'}
];

function Course (){
    const [show,setShow] =useState(false);
    const [data,setData] =useState(datainit);
    const [alertData,setAlertData] =useState(null);

    function showAlert(dataInfo) {
        setAlertData(dataInfo);
        setShow(true);
    }

    function closePopup(){
        setShow(false);
    }

    return (
        <div>
            <div>
                <Header/>
                 <div className="page course-page">
                    <Player
                        className='MP4tab'
                        autoplay
                        muted
                        sources={{
                        hd: { play_url: "https://my-video-tangxiaohan.oss-cn-hongkong.aliyuncs.com/course_video.mp4" },
                        sd: { play_url: "https://my-video-tangxiaohan.oss-cn-hongkong.aliyuncs.com/course_video.mp4" }
                        }}
                    />

                     <Classtest/>

                     <Interaction
                         data={data}
                         showAlert = {showAlert}
                     />
                     <Footer/>
                </div>
            </div>
            {show?<Popup
                data={alertData}
                closePopup = {closePopup}
            />:""}
        </div>
    )
}

export default Course;